import { ITerms } from 'src/models';
import { ITermsAgree } from 'src/screens';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 약관 조회 */
export const getTermsList = async (termsTypeCd: number) => {
  try {
    const url = `/terms?termsType=${termsTypeCd}`;

    const response = await instance.get<TApiResponseData<ITerms[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 약관 동의 내역 조회 */
export const getTermsAgree = async () => {
  try {
    const url = `/termsAgree`;

    const response = await instance.get<TApiResponseData<ITerms[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 약관 동의 내역 수정 */
export const setTermsAgree = async (agrTermsList: ITermsAgree[]) => {
  try {
    const url = `/termsAgree`;

    const response = await instance.put<TApiResponseData<ITerms[]>>(url, agrTermsList);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
